export { RoomItem } from './index.pc'
export { MobileRoomItem } from './index.mobile'
export { RoomItemSkeleton } from './skeleton.pc'
export { MobileRoomItemSkeleton } from './skeleton.mobile'
